// Copyright 2025 Merit International Inc. All Rights Reserved

import { View } from "react-native";

type Props = {
  readonly size?: number;
};

export const VerticalSpacer = ({ size = 16 }: Props) => <View style={{ height: size }} />;
